import { render, staticRenderFns } from "./ProductInstructions.vue?vue&type=template&id=27e8a8ab&scoped=true&"
import script from "./ProductInstructions.vue?vue&type=script&lang=js&"
export * from "./ProductInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ProductInstructions.vue?vue&type=style&index=0&id=27e8a8ab&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e8a8ab",
  null
  
)

export default component.exports